/*  assets/core-css-kernel.js
    paletteHub • eventHub • animQueue • clickGuard • linkActive-patch */
;(function () {
/* paletteHub */
const cur = {c1:'',c2:'',c3:'',c4:'',c5:''};
function set(o){
  let dirty=false;
  ['c1','c2','c3','c4','c5'].forEach(k=>{
    if(o[k] && o[k]!==cur[k]){ cur[k]=o[k]; dirty=true; }
  });
  if(!dirty)return;
  const r=document.documentElement;
  Object.entries(cur).forEach(([k,v])=> r.style.setProperty(`--${k}`,v));
  window.dispatchEvent(new CustomEvent('colors-changed',{detail:{...cur}}));
}
window.paletteHub={set,get:()=>({...cur})};

/* eventHub === window */
window.eventHub = window;

/* animQueue (FIFO) */
const Q=[]; let busy=false;
function pump(){ if(busy||!Q.length) return;
  busy=true; const job=Q.shift();
  (async()=>{try{job.res(await job.fn());}catch(e){job.rej(e);} busy=false; pump();})();
}
window.animQueue={
  run:fn=>new Promise((res,rej)=>{Q.push({fn,res,rej});pump();}),
  idle:()=>new Promise(ok=>window.animQueue.run(ok))
};

/* clickGuard */
let last=0;
window.clickGuard=(gap=200)=>{const n=Date.now();if(n-last<gap)return false;last=n;return true;};

/* linkActive-patch (c1↔c4, c2↔c3) */
window.linkActive=false;
const _set=CSSStyleDeclaration.prototype.setProperty;
CSSStyleDeclaration.prototype.setProperty=function(n,v,p){
  _set.call(this,n,v,p);
  if(!window.linkActive)return;
  switch(n){
    case'--c1':_set.call(this,'--c4',v,p);break;
    case'--c4':_set.call(this,'--c1',v,p);break;
    case'--c2':_set.call(this,'--c3',v,p);break;
    case'--c3':_set.call(this,'--c2',v,p);break;
  }
};
console.log('[core-css-kernel] ready');
})();
